module.exports = __webpack_public_path__ + "img/o-3.22785471.png";